<template>
  <OptionSummary></OptionSummary>

  <div class="gallery-section">
    <div class="title">
      <h2 v-if="categoryType == 'images'">گالری تصاویر</h2>
      <h2 v-if="categoryType == 'videos'">گالری ویدئوها</h2>
      <hr class="title-separator" />
    </div>
    <div class="gallery-category">
      <p
        class="image-list-btn"
        @click="
          categoryType = 'images';
          selectedCategory = '';
        "
        :class="{ 'active-gallery-category': categoryType == 'images' }"
      >
        تصاویر
      </p>
      <p
        clase="video-list-btn"
        @click="
          categoryType = 'videos';
          selectedCategory = '';
        "
        :class="{ 'active-gallery-category': categoryType == 'videos' }"
      >
        ویدئوها
      </p>
    </div>
    <categorySliderReact
      v-if="
        categoryType == 'images' && themeInfo?.info?.imageCategory.length > 0
      "
      :categoryList="themeInfo.info?.imageCategory"
      :categoryType="'imageCategory'"
      @selectedCategory="selectedCategory = $event"
    >
    </categorySliderReact>
    <categorySliderReact
      v-if="
        categoryType == 'videos' &&
        (themeInfo.info?.videoCategory.length > 0 ||
          themeInfo.info?.Video.length > 0)
      "
      :categoryList="themeInfo.info?.videoCategory"
      :categoryType="'videoCategory'"
      @selectedCategory="selectedCategory = $event"
    >
    </categorySliderReact>

    <div class="gallery-list-div">
      <transition name="leftout">
        <div class="image-gallery-list" v-if="categoryType == 'images'">
          <galleryImageCard
            v-if="managerMode == 'dataEdit'"
            :galleryItem="newImageGallery"
          ></galleryImageCard>
          <template
            v-for="(item, index) in themeInfo?.info?.imageGallery.filter(
              (el) => {
                return el.showIn != 'banner';
              }
            )"
            :key="index"
          >
            <galleryImageCard
              v-if="filterCategory(item)"
              :galleryItem="item"
              @click="fullShow($event, 'image', item.id)"
            ></galleryImageCard>
          </template>
        </div>
      </transition>

      <transition name="rightout">
        <div class="video-gallery-list" v-if="categoryType == 'videos'">
          <galleryVideoCard
            v-if="managerMode == 'dataEdit'"
            :galleryItem="newVideoGallery"
          ></galleryVideoCard>

          <template v-for="(item, index) in themeInfo.info?.videoGallery" :key="index">
            <galleryVideoCard
              v-if="filterCategory(item)"
              :galleryItem="item"
              @click="fullShow($event, 'video', item.id)"
            ></galleryVideoCard>
          </template>
        </div>
      </transition>
    </div>
  </div>

  <transition name="zoom">
    <galleryImageSlider
      :galleryItem="
        themeInfo?.info?.imageGallery.find((o) => o.id === selectedImage)
      "
      v-if="selectedImage != null"
      @selectedImage="selectedImage = $event"
    ></galleryImageSlider>
  </transition>

  <transition name="zoom">
    <galleryVideoPlayer
      :galleryItem="themeInfo.info?.videoGallery.find((o) => o.id === selectedvideo)"
      v-if="selectedvideo != null"
      @selectedvideo="selectedvideo = $event"
    ></galleryVideoPlayer>
  </transition>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import galleryImageCard from "@/components/galleryImageCard/index.vue";
import galleryImageSlider from "@/components/galleryImageSlider/index.vue";
import galleryVideoCard from "@/components/galleryVideoCard/index.vue";
import galleryVideoPlayer from "@/components/galleryVideoPlayer/index.vue";
import categorySliderReact from "@/components/categorySliderReact/index.vue";

import { galleryData } from "@/repo/galleryData.js";
import { mapGetters } from "vuex";
import { publicHelpers } from "@/public/helpers";
export default {
  name: "galleryPage",
  components: {
    OptionSummary,
    galleryImageCard,
    galleryImageSlider,
    galleryVideoCard,
    galleryVideoPlayer,
    categorySliderReact,
  },
  mixins: [galleryData, publicHelpers],
  data() {
    return {
      categoryType: "videos",
      imageCategory: ["نمایشگاه تهران", "فروشگاه", "تیم ما"],
      videoCategory: ["1400نمایشگاه تهران", "معرفی تیم", "بهترین ها"],
      selectedCategory: "",
      selectedImage: null,
      selectedvideo: null,
    };
  },
  methods: {
    fullShow(e, category, id) {
      if (e.target.getAttribute("btn") !== "like-btn") {
        if (category == "image") {
          this.selectedvideo = null;
          this.selectedImage = id;
        } else if (category == "video") {
          this.selectedImage = null;
          this.selectedvideo = id;
        }
      }
    },
    filterCategory(item) {
      if (this.selectedCategory == "") {
        return true;
      } else {
        let isCategory = false;
        if (item.hasOwnProperty("category")) {
          // item?.category.forEach((element) => {
          //   isCategory = element == this.selectedCategory ? true : isCategory;
          // });

          isCategory =
            item.category == this.selectedCategory ? true : isCategory;
        }
        return isCategory;
      }
    },
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      managerMode: "managerMode",
    }),
  },
  created() {
    if (
      this.themeInfo?.info?.imageGallery.filter((el) => {
        return el.showIn != "banner";
      }).length > this.themeInfo?.info?.videoCategory.length &&
      this.themeInfo?.info?.imageGallery.filter((el) => {
        return el.showIn != "banner";
      }).length > this.themeInfo?.info?.Video.length
    ) {
      this.categoryType = "images";
    } else {
      this.categoryType = "videos";
    }
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/gallery/gallery.css);
</style>